<div *ngIf="formGroup" [formGroup]="formGroup">
    <div class="form-group" [ngClass]="{'has-danger': invalidCode}">
        <label *ngIf="label" class="font-l1 mb-2">{{label}}</label>

        <div class="code-inputs">
            <input #code1 class="code-box" tabindex="1" maxlength="1" formControlName="code1" (keyup)="onCodeKeyup($event, 1)" (paste)="onPaste($event)" />
            <input #code2 class="code-box" tabindex="2" maxlength="1" formControlName="code2" (keyup)="onCodeKeyup($event, 2)" />
            <input #code3 class="code-box" tabindex="3" maxlength="1" formControlName="code3" (keyup)="onCodeKeyup($event, 3)" />
            <input #code4 class="code-box" tabindex="4" maxlength="1" formControlName="code4" (keyup)="onCodeKeyup($event, 4)" />
            <input #code5 class="code-box" tabindex="5" maxlength="1" formControlName="code5" (keyup)="onCodeKeyup($event, 5)" />
            <input #code6 class="code-box" tabindex="6" maxlength="1" formControlName="code6" (keyup)="onCodeKeyup($event, 6)" />
        </div>

        <small class="form-control-feedback" *ngIf="invalidCode">
            El código de verificación es requerido
        </small>
    </div>
</div>